module.exports = __webpack_public_path__ + "media/audio22.ef8ac44e.mp3";